import React from 'react'
import env from './../../environments/environment'
import appConstants from './../../constants/appConstants'
import SUPPORT_USERTYPES from './../../constants/support-access.constants'
import { toast } from 'react-toastify'
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit'
import AuthService from './../../shared/services/Auth.service'
import UserAlertsIndicator from './../users/UserAlertsIndicator/UserAlertsIndicator.component'
import UserProfileService from './../../shared/services/UserProfile.service'
import { isWhiteLabel } from './../../shared/utilities/whiteLabel.function'
import { getName } from './../../shared/utilities/getName.function'
import DashboardSearch from './DashboardSearch.component'
import { Observer } from 'mobx-react-lite'
import AgentHeadshot from './AgentHeadshot.component'
import NavBackOfficeBtn from './NavBackOfficeBtn'
import SocialMediaLinks from './SocialMediaLinks.component'
import AgentAwardLevel, { Store as AwardLevelStore } from './AgentAwardLevel.component'

import './DashboardHeader.scss'

class DashboardHeader extends React.Component {
  _activateSupportChat = () => {
    const $body = document.querySelector('body')
    if ($body) {
      if (UserProfileService.isA(SUPPORT_USERTYPES)) {
        if (!$body.classList.contains('chat-enabled')) $body.classList.add('chat-enabled')
        return
      }

      if ($body.classList.contains('chat-enabled')) $body.classList.remove('chat-enabled')
    }
  }

  _logout = () =>
    AuthService.logout().finally(() => {
      toast.success('Logout Successful')
      window.location.href = '/login'
    })

  // _renderHeadshot = () => (
  //   <img
  //     src={UserProfileService.getHeadshot()}
  //     alt="My Profile"
  //     title="My Profile"
  //     className="img-fluid d-block headshot-ratio"
  //     style={{ objectFit: 'cover' }}
  //   />
  // )

  // _renderSocialBtns = () => (
  //   <div className="social-btns">
  //     {(typeof appConstants?.social_media === 'object'
  //       ? Object.values(appConstants.social_media)
  //       : []
  //     ).map((social, idx) => (
  //       <React.Fragment
  //         key={`header-social-btn-${social.name.replace(/\s/g, '')}`}
  //       >
  //         <div className="social-btn">
  //           <a href={social.link} rel="noopener noreferrer" target="_blank">
  //             <img
  //               alt={`${social.name}`}
  //               src={`https://firebasestorage.googleapis.com/v0/b/${
  //                 social.bucket ||
  //                 env.integrations.firebase.config.storageBucket
  //               }/o/static%2F${social.icon}?alt=media`}
  //               title={`${social.name}`}
  //               className="social-icon rounded"
  //             />
  //           </a>
  //         </div>
  //         {(idx + 1) % 4 === 0 && <div className="line-break"></div>}
  //       </React.Fragment>
  //     ))}
  //   </div>
  // )

  componentDidMount() {
    this._activateSupportChat()

    if (
      UserProfileService.isA([
        'divisional-leader',
        'district-leader',
        'regional-leader',
        'career-agent',
        'limited-to-training-signature-agent',
        'signature-agent-in-need-of-pic',
        'signature-agent-complete',
        'premier-agent',
      ])
    )
      AwardLevelStore.setUser(UserProfileService.getUserId())
  }

  render() {
    const canSearch = !!this.props.userData?.can_search,
      canReceiveAward = UserProfileService.isA([
        'divisional-leader',
        'district-leader',
        'regional-leader',
        'career-agent',
        'limited-to-training-signature-agent',
        'signature-agent-in-need-of-pic',
        'signature-agent-complete',
        'premier-agent',
      ]),
      showSupportBtn = !isWhiteLabel() && UserProfileService.isA(SUPPORT_USERTYPES)

    return (
      <header id='DashboardHeaderComponent' className={`container-fluid ${(canSearch && 'can-search') || ''}`} fluid>
        <MDBRow>
          <MDBCol sm='12' md={canSearch ? '6' : '12'} xl='3' className='header-col-a'>
            {/* Toggle Navigation Menu */}
            <div className='toggle-nav-btn'>
              <div onClick={() => this.props.toggleNav()}>
                <MDBIcon icon='bars' color='white' size='2x' />
              </div>
            </div>

            {/* Home Button */}
            {isWhiteLabel() ? (
              <></>
            ) : (
              <div className='nav-bar-home-btn'>
                <NavBackOfficeBtn goTo={this.props.goTo} />
              </div>
            )}
          </MDBCol>

          <MDBCol sm='12' md={canSearch ? '6' : '12'} xl='3' className='header-col-b'>
            {/* Agent Search */}
            {canSearch ? (
              <div className='nav-bar-search'>
                <DashboardSearch
                  urlParams={this.props?.urlParams}
                  permittedScopes={
                    this.props.userData
                      ? this.props.userData.can_search
                        ? ['users', 'states', 'languages']
                        : ['states']
                      : []
                  }
                  onSearch={this.props.goTo}
                />
              </div>
            ) : (
              <></>
            )}
          </MDBCol>

          <MDBCol sm='12' md='6' xl='3' className='header-col-c'>
            {/* Social Media Buttons */}
            <div className='social-media-links'>
              <SocialMediaLinks />
            </div>
          </MDBCol>

          <MDBCol sm='12' md='6' className={`header-col-d${showSupportBtn ? '' : ' no-help-btn'}`}>
            {/* Agent Alerts */}
            <div className='alerts-btn'>
              <UserAlertsIndicator
                userId={UserProfileService.getUserId()}
                goTo={link => link && this.props.goTo(link)}
                location={this.props.location}
              />
            </div>

            {/* Agent Support */}
            {showSupportBtn ? (
              <div className='help-btn'>
                <div onClick={() => this.props.goTo('/help-support')}>
                  <MDBIcon far icon='comments' className='d-inline-inline' /> <div>Support</div>
                </div>
              </div>
            ) : null}

            {/* Agent Headshot */}
            <div className='profile-btn'>
              <AgentHeadshot />
            </div>

            {/* Agent Award Level */}
            {canReceiveAward ? (
              <Observer>
                {() =>
                  AwardLevelStore.pipLevel?.level > 0 ? (
                    <div className='agent-award-level'>
                      <AgentAwardLevel userId={UserProfileService.getUserId()} />
                    </div>
                  ) : null
                }
              </Observer>
            ) : null}

            {/* Logout Button */}
            <div className='logout-btn'>
              <div onClick={this._logout}>
                <MDBIcon icon='sign-out-alt' className='d-inline-inline' />
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </header>
    )
  }
}

export default DashboardHeader
